export default __webpack_public_path__ + "static/media/walter.6fdf002b.png";